import * as React from 'react'

const SearchTripResult = (props: any) => {
  const onChoose = () => props.onChoose(props.item)
  const placeName = props.item.placeName ? props.item.placeName + ' :' : ''
  return (
    <div className='flex items-center mb1 on-hover w100' onClick={onChoose}>
      <div>
        <p className={props.isRiderLocation ? 'm0 h5 font-blue text-start' : 'm0 h5 text-start'}>
          {(props.item.location && props.item.location.pickUpFullAddress) || `${placeName} ${props.item.fullAddress}`}
        </p>
      </div>
    </div>
  )
}
export default SearchTripResult



// WEBPACK FOOTER //
// ./src/components/trips/locations/SearchTripResult.tsx